import type {
  RateRule,
  RuleEffectType,
  RuleMarket,
  RuleScopeRef,
  RuleScopeType,
  UserTier,
} from '../dataProvider';

/**
 * The in-progress rule a preview projects (D-rate-rules). The authoring form
 * assembles this from its fields; the previews treat it as an ACTIVE, windowless
 * rule so the operator sees what WOULD resolve if it went live ("if you activate
 * this, here is who wins"). This is the projection, not the live per-click result.
 */
export interface CandidateRule {
  id?: number;
  scopeType: RuleScopeType;
  scopeRef: RuleScopeRef;
  effectType: RuleEffectType;
  effectValue: number;
  market: RuleMarket;
  tierEligibility: UserTier[];
  priority: number;
  displayLabel?: string | null;
}

/** Fill a candidate out to a full rule the resolver can rank (active, no window). */
export const candidateToRule = (c: CandidateRule): RateRule => ({
  id: c.id ?? 0,
  scopeType: c.scopeType,
  scopeRef: c.scopeRef,
  effectType: c.effectType,
  effectValue: c.effectValue,
  tierEligibility: c.tierEligibility,
  market: c.market,
  priority: c.priority,
  visibleFrom: null,
  visibleUntil: null,
  displayLabel: c.displayLabel ?? 'This rule',
  displayReasonCode: null,
  status: 'active',
  createdBy: '',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
});

/** A tier the candidate is eligible for, so the preview never hides it by tier. */
export const previewTier = (c: CandidateRule): UserTier =>
  c.tierEligibility.includes('free') ? 'free' : 'plus';
